import { useEffect, useState } from 'react';
import { useEmployeeApi } from '@apis/useEmployeeApi';

const useGetEmployeeOptionState = ({ isFetchOnMount = true } = {}) => {
    const { getEmployeesOptionsApi: doEmployeesOptionsApi } = useEmployeeApi();
    const [employeeOption, setEmployeeOption] = useState([]);

    const getEmployeeOptionApi = async () => {
        const resp = await doEmployeesOptionsApi();
        if (resp) setEmployeeOption(resp);
    };

    useEffect(() => {
        let isMounted = true;
        if (isFetchOnMount) {
            (async () => {
                const resp = await doEmployeesOptionsApi();
                if (isMounted && resp) setEmployeeOption(resp);
            })();
        }
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line
    }, [isFetchOnMount]);

    return { employeeOption, getEmployeeOptionApi };
};

export default useGetEmployeeOptionState;
